import { render, staticRenderFns } from "./DescriptionList.vue?vue&type=template&id=d79f46b4&"
import script from "./DescriptionList.vue?vue&type=script&lang=js&"
export * from "./DescriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports